import React from 'react';

export default class  Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to be assertive.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>isn't it interesting?</div>
                                            <p>Smoke starts to fill the room, what would you do…?</p>
                                            <div className="border_subtitle">Being assertive</div>
                                            <p>We’ve all been in circumstances where we’ve needed to stand up
                                                for ourselves, but we’ve felt the pressure to not do so. Being
                                                assertive is all about taking control and being able to put
                                                forward your own agenda, even in the face of opposition. Social
                                                influence and conformity can be major roadblocks to this (as the
                                                study below shows) but knowing this phenomenon and how it works
                                                can help you combat it and assert yourself in situations at
                                                work.</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Where there’s smoke…</div>
                                                <p>In a classic psychological study by Latané and Darley, <a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a> participants
                                                    were put into a room either a) by themselves, b) with 2
                                                    other participants, or c) with 2 stooges who were instructed
                                                    not to react as the experiment unfolded. Smoke was then
                                                    pumped into the room.</p>
                                                <p><span className="brown boldtext alpets">A.</span><span
                                                    className="alpets1">75% of participants who were alone left to report the smoke</span>
                                                </p>
                                                <p><span className="brown boldtext alpets">B.</span> <span
                                                    className="alpets1"> 38% of participants who were with 2 other ‘naive’ participants reported the smoke</span>
                                                </p>
                                                <p><span className="brown boldtext alpets">C.</span> <span
                                                    className="alpets1">Only 10% of participants who were with the stooges reported the smoke.</span>
                                                </p>
                                                <p style={{clear:'both'}}>It can be difficult to be assertive and
                                                    take the lead, even where there may be danger present. One
                                                    of the conclusions of this study was that togetherness may
                                                    have reduced the feeling of danger. However, the reluctance
                                                    to stand out from the crowd may have actually raised the
                                                    true level of danger.</p>
                                            </div>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>There are many situations where it is useful and important to
                                                assert yourself. This tool is about <span
                                                    className="brown brownbold">how to be assertive</span> and
                                                will help you to assert yourself in a range of situations. These
                                                include coping with criticism, making requests, stating your
                                                opinions confidently and cooperating with others to solve
                                                problems.</p>

                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}